import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import loadable from '@loadable/component';
import connectRoute from 'app/routes/connectRoute';
import LocationsActions from 'app/actions/LocationsActions';
import EventsActions from 'app/actions/EventsActions';

const LocationsPage = loadable(() => import('app/components/locations/LocationsPage/LocationsPage'));

export function LocationsPageRoute() {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(EventsActions.getEventsSettings());
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return <LocationsPage />;
}

function getRouteData({ dispatch, query }) {
  return [dispatch(LocationsActions.searchLocations(query))];
}

export default connectRoute(LocationsPageRoute, {
  getRouteData,
  debounceOptions: {
    wait: 100 // milliseconds
  }
});
